export class NumberUtil {

  static percentage(value: any, total: string | number): number {
    const percentage = Number(value) / Number(total) * 100;
    return isNaN(percentage) ? 0 : Math.ceil(percentage);
  }

}
